import { useParams } from 'react-router'

import { directRoutes, postQuoteEditRoutes } from './routeConfig'
import { Page } from 'directFlow/types'
import { FlowContext, useFlowContext } from 'directFlow/utils/FlowContext'

import { assertNever } from 'utils/assertNever'
import { createPathUtil } from 'utils/createPathUtil'

const directPath = createPathUtil(directRoutes)
export const postQuoteEditPath = createPathUtil(postQuoteEditRoutes)

/**
 * Path utility that resolve the path depending on the context
 * (if we are on the direct flow or post-quote edit).
 * This should be used in `direct-flow/` only
 */
export const useDirectFlowPath = () => {
  const { quoteId } = useParams<{ quoteId: string }>()

  if (!quoteId) {
    throw new Error('useDirectFlowPath function was used on a route without a quote ID')
  }

  const flowContext = useFlowContext()

  return (page: Page): string => {
    switch (flowContext) {
      case FlowContext.DIRECT: {
        return directPath(page, { quoteId })
      }
      case FlowContext.POST_QUOTE: {
        return postQuoteEditPath(page, { quoteId })
      }
      default: {
        return assertNever(flowContext)
      }
    }
  }
}
